import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";
import { InfoOutlineIcon } from "cxa-icons";

const Tooltip = ({ content, icon, className, children }) => {
  const prefixCls = "tooltip";

  const componentCls = classnames(prefixCls, className);

  const contentWrapperCls = `${prefixCls}__content-wrapper`;
  const contentCls = `${prefixCls}__content`;
  const iconCls = `${prefixCls}__icon`;

  const parent = icon
    ? <div className={iconCls}>
        <InfoOutlineIcon />
      </div>
    : <div className="">
        {children}
      </div>;

  return (
    <div className={componentCls}>
      {parent}
      <div className={contentWrapperCls}>
        <div className={contentCls}>
          {content}
        </div>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.array,
  icon: PropTypes.bool,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./casper/sass/components/tooltip/tooltip.js